import { Container } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import FooterNew from '../components/Footer'
import { FaAngleDown, FaAngleUp } from 'react-icons/fa'
import { useStore } from '../../app/stores/store'
import ComponentLoader from '../components/loaders/ComponentLoader'
import './services.scss'
import { ServicesItems } from '../../app/data/services'
import { CustomStepper } from '../components/stepper/CustomStepper'

function Services() {
  const { packageStore } = useStore()
  const [loadingInit, setLoadingInit] = useState(true)
  const { t } = useTranslation()
  const [activeItems, setActiveItems] = useState<number[]>([])

  const handleItemClick = (index: number) => {
    setActiveItems((prevActiveItems) => {
      if (prevActiveItems.includes(index)) {
        return prevActiveItems.filter((item) => item !== index)
      } else {
        return [...prevActiveItems, index]
      }
    })
  }

  useEffect(() => {
    if (loadingInit) {
      packageStore.loadPackages().finally(() => {
        setLoadingInit(false)
      })
    }
  }, [loadingInit, packageStore])

  if (loadingInit) return <ComponentLoader mTop={100} />


  return (
    <>
      <Container className='auction-container pb-3 pt-3'>
        <div className='overflow-x-auto fixed-height-1650'>
          <h1 className='text-center pt-5 pricing-header-1 '>{t('instructions.title')}</h1>
          <h3 className='text-center pt-2 pricing-header-2'>{t('instructions.description')}:</h3>
          <CustomStepper />
        </div>

        <div className='pb-5 mt-5'>
          <h2 className='pricing-header-1'>{t('service_details.features')}</h2>
          {ServicesItems.map((item, index) => (
            <div key={index} className='collapsible-item'>
              <div
                className={`feature-title ${activeItems.includes(index) ? 'expanded' : ''}`}
                onClick={() => handleItemClick(index)}
              >
                {t(item.title)}
                {activeItems.includes(index) ? (
                  <FaAngleUp className='text-danger' />
                ) : (
                  <FaAngleDown className='greenColor' />
                )}
              </div>
              {activeItems.includes(index) && (
                <div className='description'>
                  <p>{t(item.description)}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </Container>
      <FooterNew />
    </>
  )
}
export default observer(Services)
